/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import googleMaps from '@google/maps';
import { withTracking } from 'react-tracker';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { sites, states, googleAPIKey } from '../../../../../configPublic';
import Auth from '../Auth';
import Callout from '../../../../../components/Callout';
import Form from '../../../../../components/Form';
import Text from '../../../../../components/Form/Input/Text';
import Autocomplete from '../../../../../components/Form/Input/Autocomplete';
import Select from '../../../../../components/Form/Input/Select';
import * as SessionActions from '../../../../../actions/SessionActions';
import history from '../../../../../history';
import getOptions from '../../../../../data/fetch/getOptions';
import { getTrackingEvent } from '../../../../../tracking/events';

const messages = defineMessages({
  verifyAddress: {
    id: 'auth.address.verifyAddress',
    defaultMessage: 'Verify your address.',
    description: 'Verify your address Message',
  },
  updateAddressMessage: {
    id: 'auth.address.updateAddressMessage',
    defaultMessage: 'If this is not the correct address,',
    description: 'Update Address Message',
  },
  updateAddressLink: {
    id: 'auth.address.updateAddressLink',
    defaultMessage: 'click here to update',
    description: 'Update Address Link',
  },
  salonInfo: {
    id: 'auth.address.salonInfo',
    defaultMessage: 'First let’s set up your salon info.',
    description: 'Salon Info Message',
  },

  submittingBtn1: {
    id: 'auth.address.submittingBtn1',
    defaultMessage: '...submitting',
    description: '...submitting button text',
  },
  submittingBtn2: {
    id: 'auth.address.submittingBtn2',
    defaultMessage: 'VERIFY',
    description: 'VERIFY button text',
  },
  submittingBtn3: {
    id: 'auth.address.submittingBtn3',
    defaultMessage: 'CONTINUE',
    description: 'CONTINUE button text',
  },

  step2: {
    id: 'auth.address.step2',
    defaultMessage: 'STEP 2 OF 5',
    description: 'step2',
  },
  step3: {
    id: 'auth.address.step3',
    defaultMessage: 'STEP 3 OF 5',
    description: 'step3',
  },

  salonName: {
    id: 'auth.address.salonName',
    defaultMessage: 'Salon Name',
    description: 'salonName',
  },
  distributor: {
    id: 'auth.address.distributor',
    defaultMessage: 'Distributor',
    description: 'distributor',
  },
  salonPhoneNumber: {
    id: 'auth.address.salonPhoneNumber',
    defaultMessage: 'Salon Phone Number',
    description: 'salonPhoneNumber',
  },
  salonStreet1: {
    id: 'auth.address.salonStreet1',
    defaultMessage: 'Salon Street 1',
    description: 'salonStreet1',
  },
  salonStreet2: {
    id: 'auth.address.salonStreet2',
    defaultMessage: 'Salon Street 2 (Optional)',
    description: 'salonStreet2',
  },
  salonCity: {
    id: 'auth.address.salonCity',
    defaultMessage: 'Salon City',
    description: 'salonCity',
  },
  salonPostal: {
    id: 'auth.address.salonPostal',
    defaultMessage: 'Salon Postal',
    description: 'salonPostal',
  },
  salonState: {
    id: 'auth.address.salonState',
    defaultMessage: 'Salon State/Province',
    description: 'salonState',
  },
  salonCountry: {
    id: 'auth.address.salonCountry',
    defaultMessage: 'Salon Country',
    description: 'salonCountry',
  },
  accountNumber: {
    id: 'auth.address.accountNumber',
    defaultMessage: 'Distributor Account #',
    description: 'accountNumber',
  },
});

class Address extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    track: PropTypes.func.isRequired,
  };

  static contextTypes = {
    url: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.formSubmitHandler = this.formSubmitHandler.bind(this);
    this.verifySubmitHandler = this.verifySubmitHandler.bind(this);
    this.reviseAddressHandler = this.reviseAddressHandler.bind(this);
    this.state = {
      submitting: false,
      submitSuccess: false,
      submitError: false,
      submitErrorMessage: '',
      geocode: null,
      value: {},
    };
  }

  onChange = e => {
    const value = this.state.value;
    value[e.name] = e.value;
    this.setState({ value });
  };

  async verifySubmitHandler() {
    const { siteId } = this.context.routeParams;
    const { dispatch } = this.props;
    this.setState({
      submitting: true,
      submitSuccess: false,
      submitError: false,
    });

    const value = Object.assign(this.state.value, this.state.geocode);

    const resp = await this.context.fetch(`/${siteId}/auth/register/salon`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value),
      credentials: 'include',
    });
    const data = await resp.json();
    if (!data || resp.status !== 200 || data.responseCode === 1) {
      this.setState({
        submitError: true,
        submitErrorMessage: data.responseDesc,
        submitting: false,
      });
    } else {
      this.props.track({ type: 'SIGNUP_SALON_SUCCESS', siteId, data: null });
      dispatch(SessionActions.setMeData(data.me));
      this.setState(
        {
          submitting: false,
          submitError: false,
          submitSuccess: true,
          value: {},
        },
        () => history.push(`/${siteId}/auth/hours`),
      );
    }
  }

  async formSubmitHandler(e) {
    this.setState({
      submitting: true,
      // value: e.value,
      submitSuccess: false,
      submitError: false,
      submitErrorMessage: '',
      geocode: null,
    });
    const data = await this.lookupSmarty(
      e.value.str1,
      e.value.str2,
      e.value.city,
      e.value.state,
      e.value.postal,
      e.value.country,
    );
    if (data == null) {
      window.scrollTo(0, 0);
      return this.setState({
        submitting: false,
        submitError: true,
        submitErrorMessage: 'Invalid Address.  Please correct and try again.',
      });
    }
    return this.setState({ submitting: false, geocode: data });
  }

  async lookupSmarty(str1, str2, city, state, postal, country) {
    const { siteId } = this.context.routeParams;
    const resp = await this.context.fetch(`/${siteId}/graphql`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `{
          geocode {
            sanitizeAddressObject(address: {str1: ${JSON.stringify(
              str1,
            )}, str2: ${JSON.stringify(str2)}, city: ${JSON.stringify(
          city,
        )}, state: ${JSON.stringify(state)}, postal: ${JSON.stringify(
          postal,
        )}, country: ${JSON.stringify(country)}}) {
              str1
              str2
              postal
              state
              city
              country
              data {
                precision
                verification
              }
              loc {
                type
                coordinates
                data {
                  precision
                }
              }
            }
          }
        }`,
      }),
      credentials: 'include',
    });
    if (resp.status !== 200) throw new Error(resp.statusText);
    const json = await resp.json();
    return 'geocode' in json.data &&
      'sanitizeAddressObject' in json.data.geocode
      ? json.data.geocode.sanitizeAddressObject
      : null;
  }

  reviseAddressHandler() {
    this.setState({ geocode: null });
  }

  render() {
    const { intl } = this.context;
    const { siteId } = this.context.routeParams;
    const callout = this.state.submitError ? (
      <Callout size="small" type="warning">
        {this.state.submitErrorMessage}
      </Callout>
    ) : null;
    const content =
      this.state.geocode != null ? (
        <div className="auth__form" key="map">
          <div className="auth__step">
            <FormattedMessage {...messages.step3} />
          </div>
          <div className="auth__step-info">
            <FormattedMessage {...messages.verifyAddress} />
          </div>

          <div className="auth__main">
            <div>
              <div className="auth__verify">
                <span>{this.state.geocode.str1} </span>
                {'str2' in this.state.geocode ? (
                  <span>{this.state.geocode.str2} </span>
                ) : null}
                <span>
                  {this.state.geocode.city}, {this.state.geocode.state}{' '}
                  {this.state.geocode.postal}
                </span>
                <span> {this.state.geocode.country} </span>
              </div>
              <div className="auth__map">
                <img
                  className="img"
                  alt=""
                  src={`https://maps.googleapis.com/maps/api/staticmap?key=${googleAPIKey}&size=563x280&zoom=18&markers=color:red|${this.state.geocode.loc.coordinates[1]},${this.state.geocode.loc.coordinates[0]}`}
                />
              </div>
              <p style={{ marginTop: '30px' }}>
                <FormattedMessage {...messages.updateAddressMessage} />{' '}
                <a
                  role="button"
                  style={{ color: '#ec2027', textDecoration: 'underline' }}
                  onClick={this.reviseAddressHandler}
                >
                  <FormattedMessage {...messages.updateAddressLink} />
                </a>
                .
              </p>
            </div>
            <Form
              title={this.props.title}
              // onInvalidSubmit={this.onInvalidSubmit.bind(this)}
              onValidSubmit={this.verifySubmitHandler}
              // onSubmit={this.onSubmit.bind(this)}
              // onChange={this.onChange}
              // onCancel={this.onCancel.bind(this)}
              // onInit={this.onInit.bind(this)}
              // value={}
              isSubmitting={this.state.submitting}
              submitButtonLabel={
                this.state.submitting
                  ? intl.formatMessage(messages.submittingBtn1)
                  : intl.formatMessage(messages.submittingBtn2)
              }
            />
          </div>
        </div>
      ) : (
        <div className="auth__form" key="form">
          <div className="auth__step">
            <FormattedMessage {...messages.step2} />
          </div>
          <div className="auth__step-info">
            <FormattedMessage {...messages.salonInfo} />
          </div>

          <div className="auth__main">
            {callout}
            <Form
              title={this.props.title}
              // onInvalidSubmit={this.onInvalidSubmit.bind(this)}
              onValidSubmit={this.formSubmitHandler}
              // onSubmit={this.onSubmit.bind(this)}
              onChange={this.onChange}
              // onCancel={this.onCancel.bind(this)}
              // onInit={this.onInit.bind(this)}
              value={this.state.value}
              isSubmitting={this.state.submitting}
              submitButtonLabel={
                this.state.submitting
                  ? intl.formatMessage(messages.submittingBtn1)
                  : intl.formatMessage(messages.submittingBtn3)
              }
            >
              <Text
                label={intl.formatMessage(messages.salonName)}
                helpText=""
                errorText=""
                name="n"
                required
              />
              <div className="form-m__group" style={{ marginTop: 0 }}>
                <Autocomplete
                  required
                  multi={false}
                  label={intl.formatMessage(messages.distributor)}
                  subfieldsQuery={() => ({
                    _id: 1,
                    n: 1,
                  })}
                  helpText=""
                  name="distributors"
                  getOptions={getOptions(
                    this.context.fetch,
                    siteId,
                    'distributor',
                  )}
                  valueTransformIn={val => {
                    let output = [];
                    if (Array.isArray(val)) {
                      output = val.map(item =>
                        item.label && item.value
                          ? item
                          : {
                              value: item._id,
                              label: item.n,
                            },
                      );
                    }
                    return output;
                  }}
                  valueTransformOut={val => {
                    let output = [];
                    if (Array.isArray(val)) {
                      output = val.map(item => item.value);
                    } else if ((val || {}).value != null) {
                      output.push(val.value);
                    }
                    return output;
                  }}
                />
              </div>
              <Text
                label={intl.formatMessage(messages.accountNumber)}
                helpText=""
                errorText=""
                name="accountNumber"
                required
              />
              <Text
                label={intl.formatMessage(messages.salonPhoneNumber)}
                helpText=""
                errorText=""
                name="phone"
                required
              />
              <Text
                label={intl.formatMessage(messages.salonStreet1)}
                helpText=""
                errorText=""
                name="str1"
                required
              />
              <Text
                label={intl.formatMessage(messages.salonStreet2)}
                helpText=""
                errorText=""
                name="str2"
              />
              <Text
                label={intl.formatMessage(messages.salonCity)}
                helpText=""
                errorText=""
                name="city"
                required
              />
              <Text
                label={intl.formatMessage(messages.salonPostal)}
                helpText=""
                errorText=""
                name="postal"
                required
              />
              <Select
                label={intl.formatMessage(messages.salonState)}
                helpText=""
                errorText=""
                name="state"
                options={[{ label: '', value: '' }].concat(
                  states[siteId.toUpperCase()],
                )}
                required
              />
              <Select
                label={intl.formatMessage(messages.salonCountry)}
                helpText=""
                errorText=""
                name="country"
                options={[{ label: '', value: '' }].concat(
                  sites[siteId].countries,
                )}
                required
              />
            </Form>
          </div>
        </div>
      );

    return <Auth>{content}</Auth>;
  }
}

const mapTrackingToProps = trackEvent => ({
  track: ({ type, siteId, data }) => {
    trackEvent(getTrackingEvent({ type, siteId, data }));
  },
});

export default withTracking(mapTrackingToProps)(
  connect(state => ({ session: state.session }))(Address),
);



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/salon/Address.js